import React, { Component } from 'react';
import { Row, Col, Carousel } from 'antd';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Preloader from '../Preloader/Preloader';
import {
  CarouselCard,
  CarouselContainer,
  CarouselDiv,
  CarouselFeatured,
  CarouselHeading,
  CarouselBody,
  LearnMoreDiv,
  LeftArrow,
  RightArrow,
  CardLeaf,
} from './styles';
import { LinkNavigatorButton } from '../CTA/Buttons';
import leftArrow from '../../assets/icons/circle-arrow-l.svg';
import rightArrow from '../../assets/icons/circle-arrow-r.svg';
import greenLeaf from '../../assets/icons/logo-desktop.png';
import { fetchCarouselData } from './actions';
import { recordError } from '../../utils/commonUtil';
import { connect } from 'react-redux';
import { carouselStates } from './selectors';

class CarouselComponent extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.carousel = React.createRef();
    this.state =  {
      auto: true
    };
  }

  componentDidMount() {
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      this.props.requestData({
        metaData: {
          method: 'GET',
          url: `/dp-home-carousels?_format=json`,
          page: 'carousel',
          isExternal: false,
        },
      });
    } else {
      this.props.requestData({
        metaData: {
          method: 'GET',
          url: `/dp-home-carousels?_format=json`,
          page: 'carousel',
          isExternal: true,
        },
      });
    }
  }

  next() {
    this.setState({auto: false});
    try {
      this.carousel.next();
    } catch (error) {
      recordError(error);
    }
    this.setState({auto: true});
  }
  previous() {
    this.setState({auto: false});
    try {
      this.carousel.prev();
    } catch (error) {
      recordError(error);
    }
    this.setState({auto: true});
  }

  NavigateToPage = (link) => {
    if (link) {
      window.open(link, '_blank');
      return;
    }
    return;
  };

  render() {
    const { carouselData, isLoadingCarousel } = this.props;

    const props = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    if (isLoadingCarousel) return <Preloader />;
    return carouselData.length !== 0 ? (
      <CarouselCard
        page={this.props.isMargin}
        className='mt-xs-20'
        style={{
          backgroundImage: { greenLeaf },
        }}
        isFull={this.props.isFull}
      >
        <CarouselDiv>
          {carouselData.length > 1 ? (
            <LeftArrow onClick={this.previous} id='btnLeftArrow'>
              <img src={leftArrow} className='carousel-icons' alt='previous' />
            </LeftArrow>
          ) : (
            <div />
          )}
          <CarouselContainer isFull={this.props.isFull}>
            <Carousel ref={(node) => (this.carousel = node)} {...props} autoplay={this.state.auto}>
              {carouselData.map((data, index) => {
                return (
                  <Row key={data.title}>
                    <Col lg={this.props.isFull ? 24 : 7} sm={24}>
                      <CarouselFeatured>{data.title}</CarouselFeatured>
                      <CarouselHeading>{data.header}</CarouselHeading>
                    </Col>
                    <Col
                      lg={this.props.isFull ? 24 : 16}
                      sm={24}
                      className={this.props.isFull ? '' : 'ml-md2'}
                    >
                      <CarouselBody
                        dangerouslySetInnerHTML={{ __html: data.text }}
                      ></CarouselBody>
                    </Col>
                    <LearnMoreDiv
                      onClick={() => this.NavigateToPage(data.link)}
                      isFull={this.props.isFull}
                    >
                      <span className='tool-tip marketing-tooltip'>
                        <LinkNavigatorButton
                          buttonName={data.link_text || 'Learn more'}
                        />
                      </span>
                    </LearnMoreDiv>
                  </Row>
                );
              })}
            </Carousel>
            <CardLeaf>
              <img
                src={greenLeaf}
                className='carousel-leaf'
                alt='banner carousel'
              />
            </CardLeaf>
          </CarouselContainer>
          {carouselData.length > 1 ? (
            <RightArrow onClick={this.next}>
              <img
                src={rightArrow}
                className='carousel-icons'
                alt='next card'
                id='btnRightArrow'
              />
            </RightArrow>
          ) : (
            <div />
          )}
        </CarouselDiv>
      </CarouselCard>
    ) : (
      ''
    );
  }
}

CarouselComponent.propTypes = {
  carouselData: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }),
  isLoadingCarousel: PropTypes.any,
  isMargin: PropTypes.any,
  requestData: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...carouselStates(state.toJS())
});

const mapDispatchToProps = (dispatch) => ({
  requestData: (data) => dispatch(fetchCarouselData(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CarouselComponent)
);
